export default __webpack_public_path__ + "static/media/hawaiian-overload.2432887d.png";